<template>
    <base-modal ref="baseModal" @resetform="resetForm()" :load-data="loadData" :send="send" :valid-form="isValid">
        <template v-slot:header>
            <h3>{{$t('choose_phone_title')}}</h3>
        </template>
        <select class='form-control' v-model="selectedPhone">
            <option v-for="item of phones" :value="item.extension" v-bind:key="item.extension">{{item.name}}</option>
        </select>
    </base-modal>

</template>

<script>
import BaseModal from "./BaseModal";
import {AgentService} from "../services/agent-service";

export default {
	props: {agentService: AgentService},
	data: () => ({phones: [], selectedPhone: null}),
	components: {BaseModal},
	computed: {
		isValid() {
			return !!this.selectedPhone;
		}
	},
	methods: {
		async open() {
			this.$refs.baseModal.open();
		},
		async loadData() {
			this.phones = await this.agentService.getRegisteredPhones();
		},
		resetForm() {
			this.selectedPhone = null;
		},
		async send() {
			let result = await this.agentService.virtualLogin({extension: this.selectedPhone});
			return result == "ok" ? "ok" : false;
		}
	}
};
</script>